import React from "react";
import {AccountTreeOutlined} from "@mui/icons-material";
import Applet from "../../Applet";
import ObjectRelationshipTable from "../../../../components/Foundation/ObjectRelationshipTable";

/**
 * The edges pointing AT this object, rather than the ones it owns.
 *
 * READ ONLY, AND THAT IS THE POINT. An edge belongs to the record that created it -- the parent end
 * -- so the place to change it is over there. Offering Add or Remove here would let somebody edit a
 * relationship on a record they are not looking at, and would need a second guard saying who may.
 * Enlil drew the same line: `referenceTo` is editable, `referencedBy` is a view.
 *
 * It reads TargetRelationshipName, the phrasing from the far end: the row that says "is a component
 * of" on the parent's grid says "has component" here, and both are the same edge.
 */
class ObjectRelatedToTableApplet extends Applet {

    render() {
        return <ObjectRelationshipTable applet={this}
                                        pageSize={this.props.PageSize ?? this.state.PageSize}
                                        placement={this.state.Placement}
                                        columns={this.state.Columns}
                                        title="Related to this"
                                        icon={<AccountTreeOutlined/>}
                                        enterpriseComponent={this.getEnterpriseComponent()}
                                        sort={this.state.Sort}
                                        menu={this.state.Menu}
                                        rowHeight={this.state.RowHeight}
                                        enableSearch={false}
                                        enableSort={true}
        />;
    }

    state = {
        Name: "ObjectRelatedToTableApplet",
        Menu: {options: [{displayValue: "Refresh", value: "Refresh"}]},
        RowHeight: 48,
        PageSize: {"default": 20, "xs": 3, "sm": 3, "md": 20, "lg": 20, "lx": 20},
        Placement: {
            "xl": [
                {id: "TargetRelationshipName"},
                {id: "ParentObjectID"},
                {id: "ParentName"},
                {id: "ParentObjectClassification"},
            ],
        },
        Columns: [
            {id: "TargetRelationshipName", width: 200, cellRenderer: "Standard Single Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Relationship", hideable: false},
            {id: "ParentObjectID", width: 170, cellRenderer: "Relating Object Id Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Object ID", hideable: false},
            {id: "ParentName", flex: 1, minWidth: 300, cellRenderer: "Relating Object Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Name", hideable: false},
            {id: "ParentObjectClassification", width: 160, cellRenderer: "Classification Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Type", hideable: false},
            // NO STATUS COLUMN: the Name cell carries "Name  REV n  [STATUS]" (Ed, 2026-10-28).
        ],
        Sort: [{
            "Identifier": "Relationship",
            "Visible": true,
            "Default": true,
            "Options": [{"Direction": "ASC", "SortAttribute": "TargetRelationshipName", "DisplayName": "Relationship"}],
        }],
    };
}

export default ObjectRelatedToTableApplet;
